module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/elJCyx/images/9781459249349_fmt.jpeg?1739570927062",
      "alt": "This image is the cover for the book Staking His Claim, Billionaires and Babies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Staking His Claim, Billionaires and Babies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When her flaky sister abruptly backs  out of their surrogacy agreement,  Ella McLeod is left with a newborn  she's in no position to care for. She'll have to give the baby up for adoption. Enter Yevgeny Volkovoyher sister's bossy billionaire brother-in-law."), _c('br'), _c('br'), _vm._v("Yevgeny won't let a Volkovoy be raised by strangers; he wants custody now. How can Ella be so cold as to deny him? Even worsewhy does this woman warm his steely heart? He may be staking his claim on the baby, but Ella may stake a counterclaim on his bachelorhood."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tessa Radley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tessa Radley loves traveling, reading and watching the world around her. As a teen, Tessa wanted to be a foreign correspondent. But after completing a bachelor of arts degree and marrying her sweetheart, she ended up practicing as an attorney in a city firm. A break spent traveling through Australia re-awoke the yen to write. When she's not reading, traveling or writing, she's spending time with her husband, her two sons or her friends. Find out more at www.tessaradley.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0